// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Lf1-A,\n.Lf1-A * {\n  font-family: var(--font-family-body) !important;\n}\n\n.Lf1-A label {\n  color: var(--color-gray) !important;\n  font-weight: normal !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": "Lf1-A"
};
export default ___CSS_LOADER_EXPORT___;
